module.exports = "/boom/client/c33da3187d23d73b456be33e689a639d.svg";